import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Isvg from 'react-inlinesvg';
import Page from '../containers/page';

import logo from '../assets/images/logo.png';
import bg from '../assets/images/login-bg.png';

import upArrow from '../assets/svg/up.svg';
import downArrow from '../assets/svg/down.svg';

import visitIcon from '../assets/svg/visit.svg';
import deleteIcon from '../assets/svg/delete.svg';


import {
    Container,
    Row,
    Col,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle
} from 'reactstrap';

class ContactListPage extends Component {
    constructor(props) {
        super(props);
        this.deletePage = this.deletePage.bind(this);
        this.fetchPages = this.fetchPages.bind(this);


        this.state = {
            items: []
        };
    }

    componentDidMount() {
       this.fetchPages();


    }

    fetchPages(){
        if (!localStorage.token){
            return;
        }

        fetch('https://dpsklas.novamedia.agency/admin/fetch/contacts', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        }).then((res) => res.json()).then((result) => {
            console.log(result);
            this.setState({
                items: result
            })
        })


    }

    deletePage(id){
        if (!localStorage.token){
            return;
        }

        fetch('https://dpsklas.novamedia.agency/admin/delete/contacts/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`

            },
        }).then((res) => this.fetchPages())
    }
    render() {

        return (
            <div className="page-wrap">
                            {
                    !localStorage.token ? <Redirect to='/login' /> : null
                }

                <Container fluid className="table">

                    <Row className="page-title">
                        <Col lg="12">
                            <h3>All contacts</h3>
                        </Col>
                    </Row>
                    <Row className="table-head">
                        <Col lg="2">
                            
                            <span className="name">IME</span>
                        </Col>
                        <Col lg="4">
                            
                            <span className="name">PORUKA</span>
                        </Col>
                        <Col lg={{ size: 2, offset: 1 }}>
                            
                            <span className="name">E-MAIL</span>
                        </Col>
                        <Col lg="2" className="actions">

                            <span className="name">OPTIONS</span>
                        </Col>

                    </Row>
                    {
                        this.state.items.map((item, idx) => {
                            return (
                                <Row className="table-row">
                                    <Col lg="2">
                                        <span className="value">{item.name}</span>
                                    </Col>
                                    <Col lg="4">
                                        <span className="value">{item.message && item.message.length > 68 ? item.message.substring(0, 68) + '...' : item.message}</span>
                                    </Col>
                                    <Col lg={{ size: 2, offset: 1 }}>
                                        <span className="value">{item.email}</span>
                                    </Col>
                                    <Col lg="2" className="actions">
                                        <Link to={`/contacts/${item._id}`}><Isvg src={visitIcon} /></Link>
                                        <button onClick={() => this.deletePage(item._id)}><Isvg src={deleteIcon} /></button>

                                    </Col>

                                </Row>

                            )
                        })
                    }

                </Container>



            </div>
        );
    }
}

export default Page(ContactListPage);